import React, { createContext, useState } from 'react';

export const RenderScrollContext = createContext();

export const RenderScrollContextProvider = ({ children }) => {
  const [page, setPage] = useState({ value: 0, source: null });
  const [documentRendered, setDocumentRendered] = useState([]);
  const [zoomLevel, setZoomLevel] = useState(1);

  const getPageWidth = (index) => {
    const pageWidth = documentRendered[index]?.Width || 210; // Default A4 size
    return pageWidth;
  }

  const getPageHeight = (index) => {
    const pageHeight = documentRendered[index]?.Height || 297; // Default A4 size
    return pageHeight;
  }

  const imagesMaxWidth = documentRendered.reduce((maxWidth, _, index) => {
    const pageWidth = getPageWidth(index);

    // Get max width of all dimensions
    return Math.max(maxWidth, pageWidth);
  }, 0);

  const calculateWidthPercentageOfPage = (index) => {
    const pageWidth = getPageWidth(index);
    
    const percentage = (pageWidth / imagesMaxWidth) * 100;
    return percentage;
  }
  
  return (
    <RenderScrollContext.Provider 
      value={{ 
        page, 
        setPage,
        documentRendered,
        setDocumentRendered,
        imagesMaxWidth,
        calculateWidthPercentageOfPage,
        getPageWidth,
        zoomLevel,
        setZoomLevel,
        getPageHeight,
      }}>
        {children}
    </RenderScrollContext.Provider>
  );
};